import { request } from "../helpers/httpInterceptor";
import h from "../helpers";
import { Dispatch } from "../types/types";
import { notifyGreen } from "./notifyActions";
import {
    SET_DEPLOYMENT_DESTINATION,
    GET_DEPLOYMENT_DESTINATION,
    GET_DEPLOYMENT_DESTINATION_LIST,
    IS_DEPLOYMENT_DESTINATION_LOADING,
    IS_UPDATING_DEPLOYMENT_DESTINATION,
    GET_DEPLOY_DESTINATION_DIFF_COMPANY_LIST,
    SET_DEPLOYMENT_DESTINATION_SERVERS,
    SET_DEPLOYMENT_DESTINATION_SERVER,
    SET_DEPLOYMENT_DESTINATION_SERVERS_LOADING,
    SET_DEPLOYMENT_DESTINATION_SERVERS_SAVING,
} from "../reducers/deploymentDestination";
import {
    ICompanyDeploymentDestination,
    IDeploymentDestinationServer,
    ISaveDeploymentDestinationServerModel,
    ISetDeploymentDestinationServer,
    ISetDeploymentDestinationServers,
    ISetDeploymentDestinationServersLoading,
    ISetDeploymentDestinationServersSaving,
} from "../types/stores/deploymentDestination";
import { IDestinationExportColumn } from "../types/actions/companies";
import { ISetFlowDestinationExportIDColumns } from "../types/stores/vars";
import { SET_FLOW_DESTINATION_EXPORT_ID_COLUMNS } from "../reducers/vars";

/************************************* Deployment Destination **************************************************/
export const SetDeploymentDestination =
    (destination: ICompanyDeploymentDestination) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: SET_DEPLOYMENT_DESTINATION,
            destination,
        });
    };

export const GetDeploymentDestination =
    (destination: ICompanyDeploymentDestination) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: GET_DEPLOYMENT_DESTINATION,
            destination,
        });
    };

export const GetDeploymentDestinationsList =
    (destinations: Array<ICompanyDeploymentDestination>) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: GET_DEPLOYMENT_DESTINATION_LIST,
            destinations,
        });
    };

export const IsDeploymentDestinationsLoading =
    (isLoading: boolean) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: IS_DEPLOYMENT_DESTINATION_LOADING,
            isLoading,
        });
    };

export const IsUpdatingDeploymentDestinations =
    (isUpdating: boolean) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: IS_UPDATING_DEPLOYMENT_DESTINATION,
            isUpdating,
        });
    };

export const GetDeployDestinationsDiffCompanyList =
    (destinationsDiffCompany: Array<ICompanyDeploymentDestination>) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: GET_DEPLOY_DESTINATION_DIFF_COMPANY_LIST,
            destinationsDiffCompany,
        });
    };
/***************************************************************************************/

/************************************* Deployment Destination Servers **************************************************/

export const SetDeploymentDestinationServers = (
    servers: Array<IDeploymentDestinationServer>
): ISetDeploymentDestinationServers => ({
    type: SET_DEPLOYMENT_DESTINATION_SERVERS,
    servers,
});

export const SetDeploymentDestinationServer = (
    server: IDeploymentDestinationServer
): ISetDeploymentDestinationServer => ({
    type: SET_DEPLOYMENT_DESTINATION_SERVER,
    server,
});

export const SetDeploymentDestinationServersLoading = (
    serversLoading: boolean
): ISetDeploymentDestinationServersLoading => ({
    type: SET_DEPLOYMENT_DESTINATION_SERVERS_LOADING,
    serversLoading,
});

export const SetDeploymentDestinationServersSaving = (
    serversSaving: boolean
): ISetDeploymentDestinationServersSaving => ({
    type: SET_DEPLOYMENT_DESTINATION_SERVERS_SAVING,
    serversSaving,
});

/************************************* Destination Export ID **************************************************/

export const SetFlowDestinationExportIDColumns = (
    flowDestinationExportIDColumns: Array<IDestinationExportColumn>
): ISetFlowDestinationExportIDColumns => ({
    type: SET_FLOW_DESTINATION_EXPORT_ID_COLUMNS,
    flowDestinationExportIDColumns,
});

/***************************************************************************************/

/************************************* Deployment Destination **************************************************/

export const getDeploymentDestinationList =
    (companyId: number) =>
    (dispatch: Dispatch): void => {
        dispatch(IsDeploymentDestinationsLoading(true));
        return request(
            `/api/deploymentDestination/GetList?companyId=${companyId}`,
            {
                credentials: "same-origin",
                method: "GET",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then((data: { destinations: any }) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                dispatch(GetDeploymentDestinationsList(data.destinations));
            })
            .catch((error: any) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                h.error("Error fetching available deployment destination.", error);
            });
    };

export const getDeploymentDestinationById =
    (id: number) =>
    (dispatch: Dispatch): void => {
        dispatch(IsDeploymentDestinationsLoading(true));
        return request(
            `/api/deploymentDestination/GetById?id=${id}`,
            {
                credentials: "same-origin",
                method: "GET",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then((data: { destinations: any }) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                dispatch(GetDeploymentDestination(data.destinations));
            })
            .catch((error: any) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                h.error("Error fetching available deployment destination.", error);
            });
    };

export const addDeploymentDestination =
    (dataModel: ICompanyDeploymentDestination) =>
    (dispatch: Dispatch): Promise<void> => {
        dispatch(IsDeploymentDestinationsLoading(true));
        return fetch(`/api/deploymentDestination/Add`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(dataModel),
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as { result: boolean; destinationData: ICompanyDeploymentDestination };
                if (response.result) {
                    dispatch(notifyGreen("Destination deployment has been added"));
                    dispatch(IsDeploymentDestinationsLoading(false));
                    return;
                } else {
                    throw new Error("Error adding new deployment destination.");
                }
            })
            .catch(error => {
                dispatch(IsDeploymentDestinationsLoading(false));
                h.error("Error adding new deployment destination.", error);
            });
    };

export const updateDeploymentDestination =
    (dataModel: ICompanyDeploymentDestination) =>
    (dispatch: Dispatch): Promise<void> => {
        dispatch(IsDeploymentDestinationsLoading(true));
        return fetch(`/api/deploymentDestination/Update`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(dataModel),
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    result: boolean;
                };
                if (!response || !response.result) {
                    throw new Error("Error updating destination deployment.");
                }

                dispatch(notifyGreen("Destination deployment has been updated"));
                dispatch(IsDeploymentDestinationsLoading(false));
            })
            .catch(error => {
                // eslint-disable-next-line no-alert
                alert(error);
                h.error("Error updating destination deployment.", error);
            });
    };

export const deleteDeploymentDestination =
    (id: number, companyId: number) =>
    (dispatch: Dispatch): Promise<void> =>
        fetch(`/api/deploymentDestination/Delete?id=${id}`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    result: boolean;
                };
                if (!response || !response.result) {
                    throw new Error("Error deleting destination deployment.");
                }

                dispatch(getDeploymentDestinationList(companyId));
                dispatch(notifyGreen("Destination deployment has been removed"));
            })
            .catch(error => {
                // eslint-disable-next-line no-alert
                alert(error);
                h.error("Error deleting destination deployment.", error);
            });

export const getDeployDestinationDiffCompanyList =
    (companyId: string) =>
    (dispatch: Dispatch): void => {
        dispatch(IsDeploymentDestinationsLoading(true));
        return request(
            `/api/deploymentDestination/GetDeployDestinationDiffCompany?companyId=${companyId}`,
            {
                credentials: "same-origin",
                method: "GET",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then((data: { destinations: any }) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                dispatch(GetDeployDestinationsDiffCompanyList(data.destinations));
            })
            .catch((error: any) => {
                dispatch(IsDeploymentDestinationsLoading(false));
                h.error("Error fetching available company deploy destination.", error);
            });
    };

/**********************************/
/* DEPLOYMENT DESTINATION SERVERS */
/**********************************/
export const getDeploymentDestinationServers =
    () =>
    (dispatch: Dispatch): Promise<void> => {
        dispatch(SetDeploymentDestinationServersLoading(true));
        return request(
            "/api/deploymentDestination/GetDeploymentDestinationServers",
            {
                credentials: "same-origin",
                method: "GET",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then((data: { servers: Array<IDeploymentDestinationServer> }) => {
                dispatch(SetDeploymentDestinationServersLoading(false));
                dispatch(SetDeploymentDestinationServers(data.servers));
            })
            .catch((error: any) => {
                dispatch(SetDeploymentDestinationServersLoading(false));
                h.error("Error fetching deployment destination servers.", error);
            });
    };

export const saveDeploymentDestinationServer =
    (model: ISaveDeploymentDestinationServerModel, successCallback?: () => void) =>
    (dispatch: Dispatch): Promise<void> => {
        dispatch(SetDeploymentDestinationServersSaving(true));
        return request(
            "/api/deploymentDestination/SaveDeploymentDestinationServer",
            {
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify(model),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(SetDeploymentDestinationServersSaving(false));
                dispatch(getDeploymentDestinationServers());
                dispatch(notifyGreen("Deployment destination server has been saved."));

                if (successCallback) {
                    successCallback();
                }
            })
            .catch((error: any) => {
                dispatch(SetDeploymentDestinationServersSaving(false));
                h.error("Error saving deployment destination server.", error);
            });
    };

export const deleteDeploymentDestinationServer =
    (id: number) =>
    (dispatch: Dispatch): Promise<void> => {
        dispatch(SetDeploymentDestinationServersSaving(true));
        return request(
            `/api/deploymentDestination/DeleteDeploymentDestinationServer?id=${id}`,
            {
                credentials: "same-origin",
                method: "POST",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(SetDeploymentDestinationServersSaving(false));
                dispatch(getDeploymentDestinationServers());
                dispatch(notifyGreen("Deployment destination server has been deleted."));
            })
            .catch((error: any) => {
                dispatch(SetDeploymentDestinationServersSaving(false));
                h.error("Error deleting deployment destination server.", error);
            });
    };

/**************** Destination Export ID ****************/
/**
 * Fetches the list of export ID columns configured for a given deployment destination.
 * @param destinationId - The ID of the deployment destination to fetch export columns for.
 * @returns A thunk that returns a `Promise<void>` once the request completes.
 */
export const GetDestinationExportIDs =
    (destinationId: number) =>
    (dispatch: Dispatch): Promise<void> =>
        request(
            `/api/deploymentDestination/GetDestinationExportIDs?destinationId=${destinationId}`,
            {
                credentials: "same-origin",
                method: "GET",
                signal: null,
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as { selectedColumns: Array<IDestinationExportColumn> };
                if (response.selectedColumns) {
                    dispatch(SetFlowDestinationExportIDColumns(response.selectedColumns));
                }
            })
            .catch((error: any) => {
                h.error(`Error getting destination export columns`, error);
            });
